import { render } from "./WorksForm.vue?vue&type=template&id=47eb66fc&lang=pug"
import script from "./WorksForm.vue?vue&type=script&lang=js"
export * from "./WorksForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__